import React from 'react';
import StorytellingStyleAssessment from '../components/assessment/StorytellingStyleAssessment';

const AssessmentPage = () => {
  // The StorytellingStyleAssessment component is self-contained
  // and handles its own intro, questions, and results display
  return <StorytellingStyleAssessment />;
};

export default AssessmentPage;